import { render, staticRenderFns } from "./FilledProductDiscard.vue?vue&type=template&id=0f56b218"
import script from "./FilledProductDiscard.vue?vue&type=script&lang=js"
export * from "./FilledProductDiscard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports